"use client";

import Image from "next/image";
import React from "react";

const Footer: React.FC = () => {
  const logoClick = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="w-full">
      <div
        className="flex bg-[#B41416] w-full justify-center align-middle items-center lg:py-4 py-4 lg:text-sm text-[14px] leading-[1rem] text-white font-bold text-center cursor-pointer"
        onClick={logoClick}
      >
        <Image
          src="/newImages/MilesEducationWebsite-2024/scroll_top.png"
          alt="Special Offer"
          className="dark:invert duration-300 mr-4 w-[13px] h-[11px]"
          width={13}
          height={13}
        />
        Scroll to top
        <Image
          src="/newImages/MilesEducationWebsite-2024/scroll_top.png"
          alt="Special Offer"
          className="dark:invert duration-300 ml-4 w-[13px] h-[11px]"
          width={13}
          height={13}
        />
      </div>
      <div className="flex bg-[#030f1C] w-full lg:py-12 md:py-8 py-8 items-center">
        <div className="lg:container md:container mx-auto 2xl:px-0 xl:px-10 lg:px-6 md:px-5 flex justify-between items-center flex-wrap px_5">
          <p className="lg:text-xl md:text-lg text-xs leading-[1rem] text-white font-medium text-center cursor-pointer lg:w-auto md:w-auto w-full">
            Connect with us on social media!
          </p>
          <div className="flex items-center lg:justify-end justify-center lg:w-auto md:w-auto w-full lg:mt-0 md:mt-0 mt-5">
            <a
              href="https://www.linkedin.com/school/mileseducation/"
              target="_blank"
            >
              <Image
                src="/newImages/MilesEducationWebsite-2024/linkedin.png"
                alt="Special Offer"
                className="dark:invert duration-300 lg:mr-8 mr-4 lg:w-[22px] w-[18px]"
                width={22}
                height={26}
              />
            </a>
            <a
              href="https://www.facebook.com/Miles.Education.CPA.Review/"
              target="_blank"
            >
              <Image
                src="/newImages/MilesEducationWebsite-2024/facebook.png"
                alt="Special Offer"
                className="dark:invert duration-300 lg:mr-8 mr-4 lg:w-[28px] w-[18px]"
                width={28}
                height={32}
              />
            </a>
            <a
              href="https://www.instagram.com/miles.accounting/"
              target="_blank"
            >
              <Image
                src="/newImages/MilesEducationWebsite-2024/instagram.png"
                alt="Special Offer"
                className="dark:invert duration-300 lg:mr-8 mr-4 lg:w-[22px] w-[18px]"
                width={22}
                height={26}
              />
            </a>
            <a href="https://twitter.com/mileseducation" target="_blank">
              <Image
                src="/newImages/MilesEducationWebsite-2024/twitter.png"
                alt="Special Offer"
                className="dark:invert duration-300 lg:mr-8 mr-4 lg:w-[24px] w-[18px]"
                width={24}
                height={22}
              />
            </a>
            <a
              href="https://www.youtube.com/user/milescpareview"
              target="_blank"
            >
              <Image
                src="/newImages/MilesEducationWebsite-2024/youtube.png"
                alt="Special Offer"
                className="dark:invert duration-300 lg:w-[23px] w-[18px]"
                width={23}
                height={17}
              />
            </a>
          </div>
        </div>
      </div>
      <div className="mx-auto w-full bg-[#ffffff]">
        <div className="lg:container mx-auto bg-no-repeat bg-cover lg:p-0 px_5">
          <div className="lg:pt-16 lg:pb-8 py-10 2xl:px-0 xl:px-10 lg:px-0 px-3 pb_50">
            <div className="flex flex-wrap">
              <div className="lg:w-[34%] md:w-[38%] w-[40%] text-left">
                <p className="text-xl leading-[1.5rem] lg:text-[#000F34] text-[#B41416] sf_bold lg:mt-0 mt-0">
                  Programs
                </p>
                <a
                  href="/us-jobs-for-accountants"
                  className="lg:text-base text-[14px] leading-[1.5rem] text-[#000F34] font-normal underline decoration-solid mt-3 block"
                >
                  Miles US Pathway
                </a>
                <a
                  href="/cpa"
                  className="lg:text-base text-[14px] leading-[1.5rem] text-[#000F34] font-normal underline decoration-solid mt-3 block"
                >
                  US CPA Course
                </a>
                <a
                  href="/cma"
                  className="lg:text-base text-[14px] leading-[1.5rem] text-[#000F34] font-normal underline decoration-solid mt-3 block"
                >
                  US CMA Course
                </a>
                <a
                  href="/cfa"
                  className="lg:text-base text-[14px] leading-[1.5rem] text-[#000F34] font-normal underline decoration-solid mt-3 block"
                >
                  CFA Course
                </a>
                <a
                  href="/frm"
                  className="lg:text-base text-[14px] leading-[1.5rem] text-[#000F34] font-normal underline decoration-solid mt-3 block"
                >
                  FRM Course
                </a>
                <a
                  href="/business/executive-program-in-strategic-finance"
                  className="lg:text-base text-[14px] leading-[1.5rem] text-[#000F34] font-normal underline decoration-solid mt-3 block"
                >
                  IIM Lucknow - Strategic Finance
                </a>
              </div>
              <div className="lg:w-[25%] md:w-[20%] w-full text-left lg:inline-block md:inline-block hidden">
                <p className="text-xl leading-[1.5rem] lg:text-[#000F34] text-[#B41416] sf_bold lg:mt-0 mt-0">
                  Location
                </p>
                <a
                  href="/contact-us"
                  className="text-base leading-[1.5rem] text-[#000F34] sf_regular underline decoration-solid mt-3 block"
                >
                  Ahmedabad
                </a>
                <a
                  href="/contact-us"
                  className="text-base leading-[1.5rem] text-[#000F34] sf_regular underline decoration-solid mt-3 block"
                >
                  Bangalore
                </a>
                <a
                  href="/contact-us"
                  className="text-base leading-[1.5rem] text-[#000F34] sf_regular underline decoration-solid mt-3 block"
                >
                  Chennai
                </a>
                <a
                  href="/contact-us"
                  className="text-base leading-[1.5rem] text-[#000F34] sf_regular underline decoration-solid mt-3 block"
                >
                  New Delhi
                </a>
                <a
                  href="/contact-us"
                  className="text-base leading-[1.5rem] text-[#000F34] sf_regular underline decoration-solid mt-3 block"
                >
                  Hyderabad
                </a>
                <a
                  href="/contact-us"
                  className="text-base leading-[1.5rem] text-[#000F34] sf_regular underline decoration-solid mt-3 block"
                >
                  Kochi
                </a>
                <a
                  href="/contact-us"
                  className="text-base leading-[1.5rem] text-[#000F34] sf_regular underline decoration-solid mt-3 block"
                >
                  Kolkata
                </a>
                <a
                  href="/contact-us"
                  className="text-base leading-[1.5rem] text-[#000F34] sf_regular underline decoration-solid mt-3 block"
                >
                  Mumbai
                </a>
                <a
                  href="/contact-us"
                  className="text-base leading-[1.5rem] text-[#000F34] sf_regular underline decoration-solid mt-3 block"
                >
                  Pune
                </a>
              </div>
              <div className="lg:w-[25%] md:w-[20%] w-[40%] text-left lg:ml-0 md:ml-0 ml-10">
                <p className="text-xl leading-[1.5rem] lg:text-[#000F34] text-[#B41416] sf_bold lg:mt-0 mt-0">
                  Resources
                </p>
                <a
                  href="https://www.mileseducation.com/blogs"
                  target="_blank"
                  className="text-base leading-[1.5rem] text-[#000F34] sf_regular underline decoration-solid mt-3 block"
                >
                  Blogs
                </a>
                <a
                  href="/cpa-cma-job-opportunities-india"
                  className="text-base leading-[1.5rem] text-[#000F34] sf_regular underline decoration-solid mt-3 block"
                >
                  Accounting Jobs
                </a>
                <a
                  href="/cpa-cma-career-success-stories-india"
                  className="text-base leading-[1.5rem] text-[#000F34] sf_regular underline decoration-solid mt-3 block"
                >
                  Miles Alumni
                </a>
                <a
                  href="/contact-us"
                  className="text-base leading-[1.5rem] text-[#000F34] sf_regular underline decoration-solid mt-3 block"
                >
                  Contact Us
                </a>

                <a
                  href="/hire-accountants"
                  className="text-base leading-[1.5rem] text-[#000F34] sf_regular underline decoration-solid mt-3 block"
                >
                  Hire Accountants
                </a>
                <a
                  href="/hire-accountants/india"
                  className="text-base leading-[1.5rem] text-[#000F34] sf_regular underline decoration-solid mt-3 block"
                >
                  Hire accountants India
                </a>
                <a
                  href="https://www.milestalenthub.com/"
                  target="_blank"
                  className="text-base leading-[1.5rem] text-[#000F34] sf_regular underline decoration-solid mt-3 block"
                >
                  Hire accountants USA
                </a>
                <a
                  href="/us-jobs-for-accountants"
                  className="text-base leading-[1.5rem] text-[#000F34] sf_regular underline decoration-solid mt-3 block"
                >
                  USP
                </a>
                <a
                  href="/events"
                  className="text-base leading-[1.5rem] text-[#000F34] sf_regular underline decoration-solid mt-3 block"
                >
                  Events
                </a>
              </div>
            </div>
            <div className="text-center border-t lg:mt-14 mt-10">
              <p className="text-center pt-4 lg:text-base text-sm lg:w-auto w-full">
                © 2011 - 2024 Copyright{" "}
                <a className="underline decoration-solid" href="/">
                  Miles Education Private Limited
                </a>
              </p>
              <p className=" text-center pt-2 lg:text-base text-sm lg:w-auto w-full">
                <a
                  className="underline decoration-solid"
                  href="/terms-and-conditions"
                  target="_blank"
                >
                  Terms and Conditions
                </a>
                <span className="px-1">|</span>
                <a
                  className="underline decoration-solid"
                  href="/privacy"
                  target="_blank"
                >
                  Privacy Policy
                </a>
                <span className="px-1">|</span>
                <a
                  className="underline decoration-solid"
                  href="/sitemap"
                  target="_blank"
                >
                  Sitemap
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
